import React, { useState, useEffect } from "react";
import { Button, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress, Snackbar, Alert } from "@mui/material";
import { candidateToProgram } from "../api/api";
import { Link } from "react-router-dom";

const PostulerButton = ({ programId, isCandidate, onClick, canCandidate }) => {
  const [candidated, setCandidated] = useState(isCandidate);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    setCandidated(isCandidate);
  }, [isCandidate]);

  const candidateFuntion = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    const prevcandidated = candidated;
    setCandidated(!candidated);

    try {
      const response = await candidateToProgram(programId, token);
      if (!response.ok) throw new Error("Candidature non prise en compte");
      onClick();
      setSnackbarOpen(true);
      setIsModalOpen(false);
    } catch (error) {
      console.error("Erreur de Candidature:", error);
      setCandidated(prevcandidated);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box style={{ display: "flex", alignItems: "center" }}>
        <Button onClick={() => setIsModalOpen(true)} disabled={candidated}>
          {candidated ? "Vous avez déjà postulé à ce Programme" : "Postuler à ce Programme"}
        </Button>
      </Box>

      <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <DialogTitle>{canCandidate ? "Confirmation de candidature" : "Dossier de Candidature non complet !"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {canCandidate ? 
              "En postulant à ce programme, vous donnez accès à cette université à vos documents de candidature afin de traiter votre admission. Voulez-vous continuer ?" : 
              "Vous devez compléter votre Dossier de Candidature en téléchargeant tous les documents requis pour pouvoir postuler à ce programme."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsModalOpen(false)} color="secondary">Annuler</Button>
          {canCandidate ? (
            <Button onClick={candidateFuntion} color="primary" autoFocus disabled={loading}>
              {loading ? <CircularProgress size={20} /> : "Confirmer"}
            </Button>
          ) : (
            <Button component={Link} to="/espace-candidature" color="primary">Mes Documents</Button>
          )}
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)}>
        <Alert onClose={() => setSnackbarOpen(false)} severity="success">
          Candidature bien prise en compte !
        </Alert>
      </Snackbar>
    </>
  );
};

export default PostulerButton;
